import common from './common';

export default {
  ...common,
  featureFlagEndpoint: 'https://sdx.qa.xfinity.com/cms/data/myAccount/web/preprod/featureFlagsPreProd.json',
  firebaseConfig: {
    ...common.firebaseConfig,
    appId: '1:81318095329:web:ba8cc1d6582225fe180aa0',
  },
};
